export enum EntitySelectorTab {
	Recent = 'recents',
}
